import styled from 'styled-components';

const paddedPropsKeys = {
  sm: 'sm',
  lg: 'lg'
};

const paddedPropsValues = {
  [paddedPropsKeys.sm]: '20px',
  [paddedPropsKeys.lg]: '40px'
};

const Styles = styled.div`
  height: 100%;

  .table {
    padding-bottom: 10px;
    table-layout: fixed; // to make the cells take the width specified
    border-collapse: separate; /* Don't collapse */
  }
  .container {
    height: ${(props) => {
      if (props.fullHeight) return '100% !important';
      if (props.showBanner) return 'calc(100% - 95px) !important';
      return 'calc(100% - 60px) !important';
    }};
    overflow: ${(props) =>
      props.isLoading
        ? 'hidden'
        : props?.headerSticky
        ? 'visible'
        : 'auto'} !important;
  }

  thead {
    background: var(--sops-supertable-head-bg);
    margin: 0;
    position: sticky;
    top: ${(props) => (props?.stickyTop ? `${props?.stickyTop}px` : '0')};
    z-index: 100;
  }
  th {
    padding: 0 !important;
    vertical-align: initial;
    border-bottom: 1px solid #dedede;
    border-top: 1px solid #dedede;
    ${({ padded }) =>
      (padded === paddedPropsKeys.lg || padded === paddedPropsKeys.sm) &&
      `
      &:nth-child(1) {
        padding-left: ${paddedPropsValues[padded]} !important;
        .table-header-text {
          margin-left: 0
        }
      }
    `}
  }

  .col-header {
    .header-wrapper {
      padding: 5px 0;
      height: 50px;
      display: flex;
      position: relative;
    }
    .header-inner {
      display: flex;
      width: 98%;
      gap: 8px;
      align-items: center;
    }
    .sort-icon {
      visibility: hidden;
    }
    .filter-icon {
      opacity: 0.3;
    }

    .filter-icon.active {
      opacity: 1;
    }

    &:hover {
      .sort-icon {
        visibility: visible;
      }
      .filter-icon {
        opacity: 1;
      }
    }

    .table-header-text {
      font-size: 12px;
      font-weight: 500;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      margin-left: 10px;
      display: flex;
      gap: 8px;
    }

    .sort-wrapper {
      display: inline;
    }
    &:last-child .resizer {
      display: none;
    }
  }

  .table-content-rows {
    max-height: fit-content;
    height: 100%;
    ${({ padded }) =>
      (padded === paddedPropsKeys.lg || padded === paddedPropsKeys.sm) &&
      `
      td:nth-child(1) {
        padding-left: ${paddedPropsValues[padded]};
      }
    `}

    &.loading {
      opacity: 0.6;
      cursor: not-allowed;
      pointer-events: none;
      transition: all 0.4s;
    }

    &.disabled {
      cursor: not-allowed !important;
      td {
        pointer-events: none !important;
      }
    }

    &.selected,
    &.highlight {
      td {
        background: var(--sops-table-highlight-bg) !important;
      }
    }
  }

  .table-content {
    height: calc(100% - 50px); //reduce header height
  }

  .table > thead > tr:first-child {
    display: none !important;
  }

  tbody {
    tr {
      .action-button,
      .deleteItem {
        visibility: hidden;
      }
      .action-button-bg {
        visibility: visible;
      }
      &:hover {
        .action-button,
        .deleteItem {
          visibility: visible !important;
        }
        .action-button-bg {
          visibility: hidden;
        }
      }
    }
    tr:hover {
      td {
        background: #f5f5fc;
      }
      .editable-cell {
        background: #fff;
        border: 1px solid #d4d4d4;
      }
      .edit-actions {
        visibility: visible;
      }
    }
    .editable-cell {
      border-radius: 4px;
      height: 80%;
      font-weight: normal !important;
      border: 1px solid transparent;
    }
    td {
      height: 54px;
      background: var(--sops-table-bg);
      align-items: center !important;
      vertical-align: ${(props) => props.alignStart && 'top'} !important;
      border-bottom: 1px solid transparent;
    }
  }

  .resizer {
    display: inline-block;
    background-color: transparent !important;
    background: #ececec;
    width: 10px;
    height: 40%;
    position: absolute;
    top: 0;
    right: -4px;
    transform: translate(50%, 70%);
    z-index: 1;
    touch-action: none;
    cursor: col-resize;
    border-left: 1px solid #dedede;
    &.isResizing {
      background: red !important;
      height: 100%;
      transform: translateX(50%);
      width: 5px;
    }
  }

  .loading-state {
    position: absolute;
    top: 42%;
    left: 48%;
  }

  .ml-0 {
    margin-left: 0;
  }

  .filter-wrapper {
    margin: 0 8px;
  }

  .sops-no-bold {
    font-weight: normal !important;
  }

  .noDataCard {
    position: absolute;
    left: 40%;
    top: 0;
    margin: 0;
  }
`;

const RefreshButtonStyles = styled.div((props) => ({
  '&.refresh-notification': {
    top: '-70px !important',
    ...props.styles?.['.refresh-notification']
  },
  ...props.styles
}));

const SelectAllBannerStyles = styled.div((props) => ({
  position: 'relative',
  justifyContent: 'center',
  zIndex: 1000,
  display: 'flex',
  gap: '10px',
  padding: ' 5px 10px',
  background: '#d2efff',
  alignItems: 'center',
  '.svg-icon-wrapper': {
    position: 'relative',
    top: '3px'
  },
  '.infoMessage': {
    color: '#0B0114'
  },
  ...props.styles
}));

export default Styles;

export { SelectAllBannerStyles, RefreshButtonStyles };
